import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Styles
import './radio-button.scss';
import { stripCharacters } from '../../helpers/utils';

/**
 * @param id
 * @param srLabel: the accessible "question" to which the radio buttons answer (alternatively, provide an
 *          "aria-describedBy" in ariaProps
 * @param groupName: name of the group of radio buttons
 * @param value
 * @param listOfButtons
 * @param propertyName: the name of the key representing the value to give to the radio button
 * @param visibleProperty: the name of the property representing the visible label text of the radio buttons
 * @param selectHandler
 * @param isDisabled
 * @param ariaProps:
 *          - if no srLabel is provided, provide at least "aria-describedBy" with the id of the element describing the
 *          question to which the radio buttons answer
 * @param isRequired
 * @returns {*}
 * @constructor
 */
function RadioButton({
    id,
    srLabel,
    groupName,
    value,
    listOfButtons,
    propertyName,
    visibleProperty,
    changeHandler,
    isDisabled,
    ariaProps,
    isRequired,
    parentClasses,
    importedClasses
}) {
    const callbackAction = (e) => {
        if (changeHandler && !isDisabled) {
            changeHandler(e);
        }
    };
    const containerClasses = `radio-button__item ${parentClasses || ''}`;
    const inputClasses = `radio-button ${importedClasses || ''}`;

    return (
        <Fragment>
            {
                srLabel ? (
                    <span className="sr-only">{srLabel}</span>
                ) : ''
            }
            {
                listOfButtons.map((button, index) => {
                    const radioId = `radio-${id}-${stripCharacters(groupName)}-${index}`;
                    return (
                        <div
                            key={`radio-${groupName}-${button[propertyName]}`}
                            className={
                                `${containerClasses} ${button.isDisabled ? 'radio-button__item--disabled' : ''}`
                            }>
                            <input
                                type="radio"
                                id={radioId}
                                name={groupName}
                                value={button[propertyName]}
                                className={inputClasses}
                                onChange={callbackAction}
                                disabled={isDisabled || button.isDisabled}
                                required={isRequired}
                                checked={value === button[propertyName]}
                                {...ariaProps}
                            />
                            <label htmlFor={radioId} className="radio-button__label">
                                <span className="radio-button__label-text">{button[visibleProperty]}</span>
                            </label>
                        </div>
                    );
                })
            }
        </Fragment>
    );
}

RadioButton.defaultProps = {
    propertyName: 'value',
    visibleProperty: 'name',
    importedClasses: ''
};

RadioButton.propTypes = {
    id: PropTypes.string,
    srLabel: PropTypes.string,
    groupName: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    listOfButtons: PropTypes.array,
    propertyName: PropTypes.string,
    visibleProperty: PropTypes.string,
    isDisabled: PropTypes.bool,
    ariaProps: PropTypes.object,
    isRequired: PropTypes.bool,
    changeHandler: PropTypes.func.isRequired,
    parentClasses: PropTypes.string,
    importedClasses: PropTypes.string
};

export default RadioButton;



// WEBPACK FOOTER //
// ./components/radio-button/radio-button.js